import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import MapDetail from "../../components/map/MapDetail";

const { Content } = Layout;

function MapMag({ match }) {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">
            <Content className="layout-content">
               <MapDetail/>
            </Content>
         </Layout>
      </Layout>
   );
}

export default MapMag;
